import ReactDOM from 'react-dom/client';
import ProjectsCatalog from './ProjectsCatalog';

window.initProjectsCatalog = () => {
  const root = ReactDOM.createRoot(document.getElementById('all-projects'));
  root.render(<ProjectsCatalog />);
}
